export default __webpack_public_path__ + "static/media/social-twitter.8dc6797c.png";